/** @format */

const initialState = {
  status: "",
};

export const generalWABAReducer = (
  state = {
    waba: initialState,
  },
  action
) => {
  switch (action.type) {
    case "WABA_GET":
      return state;
    case "WABA_SET":
      return {
        ...state,
        waba: action.data,
      };
    case "WABA_RESET":
      return initialState;
    default:
      return state;
  }
};
